function getVariantClassName(_ref) {
  let {
    options,
    classes,
    selector,
    unstyled
  } = _ref;
  return (options == null ? void 0 : options.variant) && !unstyled ? classes[`${selector}--${options.variant}`] : void 0;
}

export { getVariantClassName };